import { supabase } from "@/lib/supabase/supabaseClient"
import { EditSurveyInSurveyBankProps } from "."

export const editSurveyInSurveyBank = async (props: EditSurveyInSurveyBankProps) => {
    return await supabase
        .from('survey_bank')
        .update(props)
        .eq('id', props.id!)
        .select()
        .maybeSingle()
        .throwOnError()
        .then(res => res.data);
};